module.exports = __webpack_public_path__ + "static/media/paypalLight.5cc90de9.svg";